// extracted by mini-css-extract-plugin
export var icon = "_5l-1";
export var subtext = "_5l-0";